<template>
  <p>Logowanie użytkownika...</p>
</template>

<script>
import AuthService from "./auth.service.js";
export default {
  name: "silentRenew",
  mounted: () => {
      AuthService.endSilentRenew();
  }
};
</script>